import React, {Fragment} from 'react';
import './styles/_bootstrap-grid.scss';

export const Grid = ({children}) => {
   return (
       <Fragment>
            {children}
       </Fragment>
    );
}